import ButtonLink from 'common/components/Elements/ButtonLink/ButtonLink';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatCommandUrl } from 'core/utilities/command/command';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandLink({ command, small }: ComponentProps) {
  const {
    id, title, active, shortcut, action, label, icon, styleHint,
  } = command;

  const ref = React.createRef<HTMLButtonElement>();

  const shortcutTrigger = useShortcut(...(shortcut || []));

  useEffect(() => {
    if (shortcutTrigger && ref && ref.current) {
      ref.current.click();
    }
  }, [shortcutTrigger, ref]);

  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);

  const url = formatCommandUrl(jsfUrl, command);
  if (!url) return null;

  return (
    <ButtonLink
      action={action || 'tertiary'}
      className={classes.command}
      title={title}
      small={small}
      disabled={active === false}
      e2eId={id}
      buttonRef={ref}
      url={url}
      buttonIcon={(icon && !label) || styleHint !== undefined}
    >
      <CommandLinkContent command={command} />
    </ButtonLink>
  );
}

export default CommandLink;
